import {
    GET_ONLY_PRICES,
    GET_SUBSCRIPTION_DETAILS_SUCCESS,
    UPADTE_CUSTOMER_DETAILS,
    UPDATE_CUSTOMER_PM,
} from "../constant";

const initial = {
    customerDetails: null,
    customerPM: null,
    subscriptionsDetails: null,
    prices: null
};

export const SubscriptionReducer = (state = initial, action) => {
    switch (action.type) {
        case GET_SUBSCRIPTION_DETAILS_SUCCESS:
            return {
                ...state,
                customerDetails: action.payload.customerDetails,
                customerPM: action.payload.customerPM,
                subscriptionsDetails: action.payload.subscriptionsDetails,
                prices: action.payload.prices
            }
        case UPADTE_CUSTOMER_DETAILS:
            return {
                ...state,
                customerDetails: action.payload
            }
        case UPDATE_CUSTOMER_PM:
            return {
                ...state,
                customerPM: action.payload
            }
        case GET_ONLY_PRICES:
            return {
                ...state,
                prices: action.payload
            }
        default:
            return state;
    }
};